<template>
  <b-row>
    <b-col cols="12">
      <leave-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import LeaveAddForm from './LeaveAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    LeaveAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
